import apiService from './apiService';
import { GET } from './executer';

/**
 * File entry in stations bucket
 */
export interface StationBucketFile {
  name: string;
  path: string;
  timeCreated: string;
  /** True if a row exists in station_observations for this file's timestamp */
  ingested?: boolean;
}

/**
 * Per-station status
 */
export interface StationStatus {
  reference: string;
  stationId: string;
  bucket: string;
  pathPrefix: string;
  expectedFile: string;
  expectedFileExists?: boolean;
  expectedFileTimeCreated?: string | null;
  expectedFileIngested?: boolean;
  latestFile: string | null;
  timeCreated: string | null;
  latestFiles: StationBucketFile[];
  isDelayed: boolean;
  message: string;
}

/**
 * Stations status response
 */
export interface StationsStatusResponse {
  stations: StationStatus[];
  hasEvent: boolean;
  anyDelayed?: boolean;
  message?: string;
}

class StationsStatusService {
  /**
   * Get status for all stations of the current event.
   * Requires root user.
   */
  async getStationsStatus(token: string): Promise<StationsStatusResponse> {
    const response = await apiService.client.execute<StationsStatusResponse>(
      GET,
      '/api/stations-status',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.errorData?.message || 'Failed to fetch stations status');
  }
}

export const stationsStatusService = new StationsStatusService();
export default stationsStatusService;
